<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="grid1"
      :columns="gridColumns0"
      :dataset="'ds0'"
      :multiselect="true"
      :showDisplayCountControl="false"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          v-permission:create="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="addRow"
        >
          {{ $t('MSG_BTN_ROW_ADD') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="deleteRows"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        :disabled="checkMetaSave"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';
export default {
  name: 'PGE_CMU_00001_T05', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    selectedPageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PRMT_NM'),
        datafield: 'pageParameterName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
            'maxlength': '25',
          }, this.ds0, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRMT_VAL'),
        datafield: 'pageParameterValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
            'maxlength': '50',
          }, this.ds0, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      checkMetaSave: utils.checkMetaSave(),
    };
  },
  computed: {},
  watch: {
    selectedPageId(value) {
      if (utils.isEmpty(value)) {
        this.tapGridClear();
      } else {
        this.pageParamListLoad();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedPageId)) {
        this.pageParamListLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    pageParamListLoad() {
      http.request(this.pageId, 'DTS_CMU_00062', {
        path: {
          'page-id': this.selectedPageId,
        },
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    tapGridClear() {
      this.ds0.setRawData([]);
    },
    rowInitData() {
      return [{
        pageId: this.selectedPageId,
        pageParameterName: '',
        pageParameterValue: '',
      }];
    },
    addRow() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PAGE')));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      } else {
        // addRows
        this.ds0.addRows(this.rowInitData());
      }
    },
    deleteRows() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PAGE')));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      } else {
        // deleteRows
        const indexes = this.ds0.getSelectedIndexes();
        this.ds0.deleteRows(indexes);
      }
    },
    onSaveClick() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PAGE')));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      } 

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null,
        (/* ok */) => {
          // save
          const saveData = this.ds0.getRawData();
          const validResult = this.validation(saveData);
          if (validResult.valid) {
            this.saveAction(saveData);
          } else {
            utils.messageBox('warning', validResult.msg, null, () => {
              this.$refs.grid1.setFocus(validResult.row, validResult.column);
            });
          }
        },
        (/* cancel */) => {});
    },
    validation(saveData) {
      const result = {
        valid: true,
        msg: '',
        row: 0,
        column: '',
      };
      utils.forEach(saveData, (data, index) => {
        if (utils.isEmpty(data.pageParameterName)) {
          result.valid = false;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), index + 1, this.$t('MSG_TXT_PRMT_NM'));
          result.row = index;
          result.column = 'pageParameterName';
          return false;
        }
        if (utils.isEmpty(data.pageParameterValue)) {
          result.valid = false;
          result.msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'), index + 1, this.$t('MSG_TXT_PRMT_VAL'));
          result.row = index;
          result.column = 'pageParameterValue';
          return false;
        }
        return true;
      });
      return result;
    },
    saveAction(saveData) {
      http.request(this.pageId, 'DTS_CMU_00063', {
        path: {
          'page-id': this.selectedPageId,
        },
        data: saveData,
      }).then(() => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
        this.ds0.submit();
      }).catch(error => {
        console.log(error);
      });
    },
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'pageParameterName',
      type: 'string',
      map: 'pageParameterName',
    }, {
      name: 'pageParameterValue',
      type: 'string',
      map: 'pageParameterValue',
    }, {
      name: 'pageId',
      type: 'string',
      map: 'pageId',
    }],
  }],
};
</script>
<style scoped>
</style>
